export default __webpack_public_path__ + "static/media/1.94052b5d.jpg";